export const viewPortTypes = {
  SET_MOBILE_VIEWPORT: 'SET_MOBILE_VIEWPORT',
  SET_TABLET_VIEWPORT: 'SET_TABLET_VIEWPORT',
  SET_DESKTOP_VIEWPORT: 'SET_DESKTOP_VIEWPORT',
};
